import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import '../styles/SideMenu.css'

const SideMenu = ({ onOptionClick, darkMode, setDarkMode, vocabFile }) => {
  const [categories, setCategories] = useState([])

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`/data/${vocabFile}`)
        const jsonData = await response.json()
        setCategories(Object.keys(jsonData))
      } catch (error) {
        console.error('Error al cargar las categorías:', error)
      }
    }

    fetchCategories()
  }, [vocabFile])

  // Cambia el color de fondo y texto según darkMode
  const menuBg = darkMode ? '#23272a' : '#f4f4f4'
  const menuColor = darkMode ? '#f5f5f5' : '#111'
  const borderColor = darkMode ? '#444' : '#ddd'

  return (
    <div
      className='side-menu'
      style={{
        backgroundColor: menuBg,
        color: menuColor,
        borderRight: `1px solid ${borderColor}`
      }}
    >
      <h2 style={{ color: menuColor }}>Categorías</h2>
      <div className='side-menu-scroll'>
        <ul className='side-menu-list'>
          <li className='side-menu-item' style={{ borderBottom: `1px solid ${borderColor}` }}>
            <Link
              to='/'
              className='side-menu-link'
              style={{ color: menuColor }}
              onClick={onOptionClick}
            >
              Inicio
            </Link>
          </li>
          {categories.map((category, index) => (
            <li
              key={index}
              className='side-menu-item'
              style={{ borderBottom: `1px solid ${borderColor}` }}
            >
              <Link
                to={`/flipcards/${category}`}
                className='side-menu-link'
                style={{ color: menuColor }}
                onClick={onOptionClick}
              >
                {category}
              </Link>
            </li>
          ))}
          <li className='side-menu-item' style={{ borderBottom: `1px solid ${borderColor}` }}>
            <Link
              to='/quiz-particulas'
              className='side-menu-link'
              style={{ color: menuColor }}
              onClick={onOptionClick}
            >
              Quiz Partículas
            </Link>
          </li>
          {/* <li className='side-menu-item' style={{ borderBottom: `1px solid ${borderColor}` }}>
            <Link
              to="/custom-flashcards"
              className='side-menu-link'
              style={{ color: menuColor }}
              onClick={onOptionClick}
            >
              Flashcards Personalizadas
            </Link>
          </li> */}
          <li className='side-menu-item' style={{ borderBottom: `1px solid ${borderColor}` }}>
            <Link
              to='/drag-drop'
              className='side-menu-link'
              style={{ color: menuColor }}
              onClick={onOptionClick}
            >
              Insertar particula
            </Link>
          </li>
          <li className='side-menu-item' style={{ borderBottom: `1px solid ${borderColor}` }}>
            <Link
              to='/global-review'
              className='side-menu-link'
              style={{ color: menuColor }}
              onClick={onOptionClick}
            >
              Repaso Global
            </Link>
          </li>
          <li className='side-menu-item' style={{ borderBottom: `1px solid ${borderColor}` }}>
            <Link
              to='/buscar'
              className='side-menu-link'
              style={{ color: menuColor }}
              onClick={onOptionClick}
            >
              Buscador
            </Link>
          </li>
          {/* <li className='side-menu-item' style={{ borderBottom: `1px solid ${borderColor}` }}>
            <div>
              <Switch
                title='modo oscuro'
                checked={darkMode}
                onChange={() => setDarkMode((v) => !v)}
              />
            </div>
          </li> */}
        </ul>
      </div>
      {/* Switch modo oscuro anclado abajo
      <div
        className='side-menu-footer'
        style={{ borderTop: `1px solid ${borderColor}`, background: menuBg }}
      >
        <label className='side-menu-dark-toggle' style={{ color: menuColor }}>
          <input
            type='checkbox'
            checked={darkMode}
            onChange={() => setDarkMode((v) => !v)}
            style={{ accentColor: '#0974f1' }}
          />
          <span>Modo oscuro</span>
        </label>
      </div>
      */}
    </div>
  )
}

export default SideMenu
